export default "__VITE_ASSET__d0fd2bfa__"